import React, { Component } from 'react';
import ConfigurationStep1Page from './config-step-1-html';
class ConfigurationStep1 extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <ConfigurationStep1Page
                />
            </div>
        )
    }
}
export default ConfigurationStep1;